module.exports = __webpack_public_path__ + "img/agoric-small-dark.64ad8d0c.svg";